import { CancelToken } from 'src/utils/http';

import {
  setAutocompleteLatestSearch,
  updateWorkplaceAutocompleteSuggestions,
  updateKeywordAutocompleteSuggestions
} from 'src/redux/actions/searchParams';

import storage from 'src/api/storage';


const latestSearchLocalStorageName = 'latestSearch';

const fetchLatestSearch = () => {
  const latestSearch = JSON.parse(storage.getItem(latestSearchLocalStorageName) || '{}');
  return setAutocompleteLatestSearch(latestSearch);
};

const fetchAutocomplete = ({
  url, query, callbackFn, dictionaries, cancelCallbackFn
}) => (dispatch, getState, { http }) => http({
  url,
  params: {
    limit: 15,
    query,
    dictionaries
  },
  withCredentials: false,
  cancelToken: new CancelToken((cancelToken) => {
    cancelCallbackFn(cancelToken);
  })
})
  .then(response => dispatch(callbackFn(response.data)))
  // made on purpose, we do not handle errors caused by autocomplete api
  .catch(() => { });


const cancelFetchAutocomplete = (cancel) => {
  if (cancel) {
    cancel();
  }
};

let keywordAutocompleteCancel = null;
const fetchKeywordAutocomplete = (query, dispatch) => dispatch(fetchAutocomplete({
  url: '/suggestion',
  query,
  callbackFn: updateKeywordAutocompleteSuggestions,
  dictionaries: 'jobTitles,employers,skills',
  cancelCallbackFn: (cancelToken) => { keywordAutocompleteCancel = cancelToken; }
}));

const cancelFetchKeywordAutocomplete = () => cancelFetchAutocomplete(keywordAutocompleteCancel);

let workplaceAutocompleteCancel = null;
const fetchWorkplaceAutocomplete = (query, dispatch) => dispatch(fetchAutocomplete({
  url: '/location',
  query,
  callbackFn: updateWorkplaceAutocompleteSuggestions,
  cancelCallbackFn: (cancelToken) => { workplaceAutocompleteCancel = cancelToken; }
}));

const cancelFetchWorkplaceAutocomplete = () => cancelFetchAutocomplete(workplaceAutocompleteCancel);

export {
  fetchLatestSearch,
  fetchKeywordAutocomplete,
  cancelFetchKeywordAutocomplete,
  fetchWorkplaceAutocomplete,
  cancelFetchWorkplaceAutocomplete
};
